import { useEffect, useState } from "react"
import { RadioGroup } from "@headlessui/react"
import { langs } from "."
import { useTranslation } from "react-i18next"

function RadioGroup1({ label, name, value, options, onChange, disabled }) {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      disabled={disabled}
      name={name}
    >
      <RadioGroup.Label className="font-semibold text-gray-700">
        {label}
      </RadioGroup.Label>
      <div className="flex flex-col gap-2">
        {options.map((o) => (
          <RadioGroup.Option key={o.id} value={o.code}>
            {({ checked }) => (
              <div className="flex items-center justify-start gap-2">
                <div
                  className={`
                    flex h-5 w-5 items-center justify-center rounded-full transition-all duration-200 outline-none ring-1 cursor-pointer
                    ${!checked && !disabled ? "ring-gray-400" : ""}
                    ${
                      checked && !disabled
                        ? "ring-[color:var(--custom-primary)]"
                        : ""
                    } 
                    ${disabled ? "bg-gray-200 ring-gray-200" : "bg-white"}  
                  `}
                >
                  <span
                    className={`
                      w-3 h-3 rounded-full
                      ${checked ? "scale-100" : "scale-0"}
                      ${
                        checked && !disabled
                          ? "bg-[color:var(--custom-primary)]"
                          : "bg-gray-400"
                      }
                      transition-transform duration-200 ease-out`}
                  />
                </div>
                <div className="text-xl font-medium">{o.tittle}</div>
              </div>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  )
}

function RadioSelect({ closeModal }) {
  const [activelang, setActiveLang] = useState("uz")
  const { i18n, t } = useTranslation()

  useEffect(() => {
    const defaultLang = localStorage.getItem("lang")
    setActiveLang(defaultLang)
  }, [])

  //Creating a method to change the language onChnage from select box
  const changeLanguageHandler = (lang) => {
    i18n.changeLanguage(lang)
    localStorage.setItem("lang", lang)
    setActiveLang(lang)
  }
  return (
    <div className="relative flex flex-col w-full max-w-md gap-8 p-5 bg-white rounded-md sm:p-10">
      <RadioGroup1
        name="language"
        label=""
        value={activelang}
        onChange={(val) => changeLanguageHandler(val)}
        options={langs}
      />
      <button
        className="w-full bg-[color:var(--custom-primary)] text-white font-medium text-lg py-2"
        onClick={closeModal}
      >
        {t("close")}
      </button>
    </div>
  )
}

export { RadioSelect }
